import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { functionpermission, GetMenusBO, saveMenusBo, sideMenuItemsIdBo } from './menus-new.modal';
import { MenusService } from './menus-new.service';
import { MenusDateService } from './menus-newdateservice';
@Component({
  selector: 'app-menus-new',
  templateUrl: './menus-new.component.html',
  styleUrls: ['./menus-new.component.scss']
})
export class MenusNewComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('gridMenus') public gridMenus: GridComponent;
  public filterSettings: object;
  MenuList: any = [];
  isshowFunction: boolean = false;
  selectMenuFilter: any = [];
  MenuNames: string;
  isSaveorUpdateBoolean:boolean=false;
  sideMenuId: sideMenuItemsIdBo = new sideMenuItemsIdBo();
  saveMenuInfo: saveMenusBo = new saveMenusBo();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  MenusFilterBo: GetMenusBO = new GetMenusBO();
  public GridList: Observable<DataStateChangeEventArgs>;
  constructor(public DateService: MenusDateService,
    public MService: MenusService,
    public global: GlobalComponent,
    public toasterservice: ToastrService) {
    this.global.checkforlogout();
    this.GridList = DateService;
  }
  fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    this.filterSettings = {
      type: 'Menu',
    };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.MenusFilterBo.field = "title";
    this.MenusFilterBo.orderColumn = "title";
    this.getMenuFilter();
    this.getpermission();
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "Menus");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.MService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}
  //.........................................dataChangeMenus.....................................................
  public dataChangeMenus(M): void {
    let val = (M.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((M.sorted || []).length) {
        this.MenusFilterBo.orderColumn = M.sorted[0].name;
        this.MenusFilterBo.orderType = M.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && M.action.action != "clearFilter") {
      this.MenusFilterBo.value = M.action.currentFilterObject.value;
      this.MenusFilterBo.field = M.action.currentFilterObject.field;
      this.MenusFilterBo.matchCase = M.action.currentFilterObject.matchCase;
      this.MenusFilterBo.operator = M.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && M.action.action == "clearFilter") {
        this.MenusFilterBo.field = "title";
        this.MenusFilterBo.matchCase = false;
        this.MenusFilterBo.operator = "contains";
        this.MenusFilterBo.value = "";
        this.MenusFilterBo.type = "string";
      }
    }
    this.getMenuFilter();
    if (val == "paging" && M.action.name == "actionBegin") {
      // if (this.arraycol.length != 0) {
      //   if (this.arraycol[0].Question.Pagesize != Q.take) {
      //     this.arraycol[0].Question.Pagesize = Q.take
      //     // this.SaveColumnwidth();
      //   }
      // }
    }
  }
  //.........................................onActionMenus.....................................................
  public onActionMenus(M) {
    this.MenusFilterBo.currentpageno = this.gridMenus.pagerModule.pagerObj.currentPage;
    this.MenusFilterBo.pageitem = this.gridMenus.pagerModule.pagerObj.pageSize;
    if (M.name == "actionBegin" && M.requestType == "filterbeforeopen") {
      this.MenusFilterBo.type = M.columnType
    }
  }
  //...........................................getDetails..........................................
  getDetails(saveBos: saveMenusBo) {
    this.saveMenuInfo = JSON.parse(JSON.stringify(saveBos));

  }
  //...........................................Refresh...........................................
  Refresh() {
    this.saveMenuInfo = new saveMenusBo();
    this.selectMenuFilter = null;
    this.MenusFilterBo.field = "title";
    this.MenusFilterBo.orderColumn = "title";
    this.getParentMenus();
  }
  //...............................................getMenuFilter......................................
  getMenuFilter() {
    this.getParentMenus();
  }
  //...................................menuListFilter..................................................
  menuListFilter() {
    if (this.selectMenuFilter == null || this.selectMenuFilter == undefined || this.selectMenuFilter == '' ||
      this.selectMenuFilter == "00000000-0000-0000-0000-000000000000") {
      this.getParentMenus();
    }

    else {
      let a = this.MenuList?.filter(a => a.id == this.selectMenuFilter)[0];
      this.MenuNames = a.title;
      this.MenusFilterBo.field = "title";
      this.MenusFilterBo.orderColumn = "title";
      this.getSubMenus();
    }
  }
  //.......................................getParentMenus............................................
  getParentMenus() {

   
    this.DateService.executeParentMenu(this.MenusFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1;
      this.MenuList = this.DateService.getDroplist()
      if (data != null && data.result.length > 15) {
        this.gridMenus.height = '500';
      }
      else {
        this.gridMenus.height = 'auto';
      }
    })
  }
  //.......................................getSubMenus............................................
  getSubMenus() {
   
    this.MenusFilterBo.sideMenuId = this.selectMenuFilter;
    this.DateService.executeSubMenu(this.MenusFilterBo);
    let count = 0;
    this.GridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      count = count + 1;
      if (data != null && data.result.length > 15) {
        this.gridMenus.height = '500';
      }
      else {
        this.gridMenus.height = 'auto';
      }
    })
  }
  //.........................................SaveOrUpdateMenu.............................................
  SaveOrUpdateMenu() {
    this.isSaveorUpdateBoolean=true;
    let savepayload: saveMenusBo = JSON.parse(JSON.stringify(this.saveMenuInfo));
    savepayload.id = this.saveMenuInfo.id;

    savepayload.parentMenuItemId = (this.selectMenuFilter != null && this.selectMenuFilter != undefined && this.selectMenuFilter != '') ? this.selectMenuFilter : null;
    this.MService.SaveorUpdateMenuItems(savepayload).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveorUpdateBoolean=false;
      if (this.saveMenuInfo.id == '00000000-0000-0000-0000-000000000000') {
        this.toasterservice.success('Menus saved successfully!');
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      }
      else if (this.saveMenuInfo.id != '00000000-0000-0000-0000-000000000000') {
        this.toasterservice.success('Menus updated successfully!');
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      }
      document.getElementById('openMenuModal').click();
      this.saveMenuInfo = new saveMenusBo();
      this.MenusFilterBo.sideMenuId = "00000000-0000-0000-0000-000000000000"
      this.selectMenuFilter = null;
      this.getMenuFilter();

    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toasterservice.error(err, 'Error'), 8000;
      }
    })
  }
  closeModal() { this.saveMenuInfo = new saveMenusBo(); }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

